export default "__VITE_ASSET__BX6Bcp7i__"